// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jsEd","questions":"styles_questions__yKJN6","footer":"styles_footer__3YCbA"};